export default __webpack_public_path__ + "static/media/willy-wonka.2b102c7c.jpeg";